<template>
  <div
    class="reappro__product product"
    v-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true"
  >
    <div class="product__image-container">
      <img
        class="product__image"
        alt=""
        v-if="item.photos && item.photos[0]"
        :src="imagesurl + '600/' + item.photos[0].name"
      />
      <img v-else class="product__image" src="/static/img/600x400.jpg" alt="" />
    </div>
    <div class="product__info-container">
      <div class="product__info-main">
        <div class="product__name-container">
          <h3 class="product__name">{{ item.label }}</h3>
        </div>
      </div>
      <p class="product__code">Code article : {{ item.code }}</p>
    </div>
    <div class="product__footer">
      <div class="product__footer-left">
        <span class="footer__info-title">Etat du stock : </span>
        <div class="product__stock-container">
          <div class="product__stock stock">
            <div
              v-if="
                item.vehicleStocks[0] &&
                item.vehicleStocks[0].stock < item.vehicleStocks[0].minStock
              "
              class="stock__picto red"
            >
              <img src="/static/img/pictos/camionstockssbulle.svg" alt="" />
            </div>
            <div
              v-else-if="
                item.vehicleStocks[0] &&
                item.vehicleStocks[0].stock == item.vehicleStocks[0].minStock
              "
              class="stock__picto orange"
            >
              <img src="/static/img/pictos/camionstockssbulle.svg" alt="" />
            </div>
            <div v-else-if="item.vehicleStocks[0]" class="stock__picto green">
              <img src="/static/img/pictos/camionstockssbulle.svg" alt="" />
            </div>
            <span class="stock__number" v-if="item.vehicleStocks[0]">{{
              item.vehicleStocks[0].stock
            }}</span>

            <div
              v-if="item.productShops[0] && item.productShops[0].stock == 0"
              class="stock__picto magasin rouge"
            >
              <img src="/static/img/pictos/magasinstockssbulle.svg" alt="" />
            </div>
            <div
              v-else-if="item.productShops[0] && item.productShops[0].stock <= 10"
              class="stock__picto magasin orange"
            >
              <img src="/static/img/pictos/magasinstockssbulle.svg" alt="" />
            </div>
            <div v-else-if="item.productShops[0]" class="stock__picto magasin green">
              <img src="/static/img/pictos/magasinstockssbulle.svg" alt="" />
            </div>
            <span class="stock__number" v-if="item.productShops[0]">{{
              item.productShops[0].stock
            }}</span>
          </div>
        </div>
      </div>
      <div class="product__footer-right">
        <span class="footer__info-title">Quantité : </span>
        <div class="product__quantity-container quantity">
          <div class="quantity__container">
            <input
              type="text"
              class="quantity__value"
              name=""
              v-model="qt"
              @change="getQuantity(qt)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductCartModal",
  props: ["item"],
  data() {
    return {
      qt: 1,
    };
  },
  computed: {
    imagesurl() {
      return process.env.BACK_UPLOADS_URL;
    },
  },
  methods: {
    getQuantity(qt) {
      this.$emit("qt", this.qt);
    },
  },
  mounted() {},
};
</script>


<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

.product {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  position: relative;
  background-color: white;
  width: 100%;
  height: auto;
  &__image-container {
    width: 50%;
    height: 185px;
  }
  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &__info-container {
    width: 50%;
    height: 185px;
    padding: 20px;
  }
  &__info-main {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 100%;
    align-items: top;
    .product__name-container {
      width: 100%;
      line-height: 1;
    }
  }
  &__footer {
    width: 100%;
    display: flex;
    padding: 10px;
    .footer__info-title {
      font-size: 12px;
      color: $grisfonce;
      font-family: "ClanPro";
      display: block;
      width: 100%;
      text-transform: uppercase;
    }
  }
  &__footer-left {
    width: 50%;
    display: flex;
    flex-direction: column;
  }
  &__footer-right {
    width: 50%;
    display: flex;
    flex-direction: column;
  }
  &__name {
    font-size: 15px;
    text-transform: uppercase;
    font-family: "ClanFFBlack";
    color: $mystockblue;
    text-align: left;
  }
  &__code {
    font-size: 12px;
    color: $grisfonce;
    font-family: "ClanPro";
    text-align: left;
  }
  .quantity {
    flex: 1;
    display: flex;
    justify-content: center;
    &__value {
      width: 55px;
      height: 55px;
      border-radius: 50%;
      background-color: $grisclair;
      display: inline-block;
      line-height: 55px;
      text-align: center;
      border: none;
      outline: none;
      font-family: "ClanFFBlack";
      font-weight: normal;
      color: $color1;
    }
    &__container {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      width: 50%;
      span {
        display: block;
        font-size: 12px;
        text-transform: uppercase;
        font-family: "ClanFFBlack";
        color: $color1;
        margin-top: 4px;
      }
    }
  }
  &__stock-container {
    padding-top: 15px;
    display: flex;
    justify-content: center;
  }
  .stock {
    width: 50%;
    text-transform: uppercase;
    font-family: "ClanPro";
    color: $grisfonce;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: center;
    &__picto {
      width: 30px;
      margin-left: 20px;
      position: relative;
      img {
        width: 100%;
      }
      &.magasin {
        img {
          width: 25px;
        }
      }
      &:before {
        content: "";
        display: block;
        width: 24px;
        height: 24px;
        opacity: 0.75;
        position: absolute;
        top: 0;
        left: 0;
        margin-left: -10px;
        margin-top: -10px;
        border-radius: 50%;
      }
      &.green {
        &:before {
          background: $vert;
        }
      }
      &.red {
        &:before {
          background: $rouge;
        }
      }
      &.orange {
        &:before {
          background: $orange;
        }
      }
    }
    &__number {
      text-align: center;
      margin: 0 10px;
      font-family: "ClanFFBlack";
      color: $grisfonce;
      font-size: 16px;
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Product/ProductCartModal.vue